import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminUsersListPage = () => {
  return (
    <>
      <Helmet>
        <title>Users list - AutoScript Admin</title>
      </Helmet>

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
